'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _markup = require('./markup');

var _markup2 = _interopRequireDefault(_markup);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var render = {
  placeholder: function placeholder(config) {
    (0, _jquery2.default)(_constants.DOM_IDS.header).remove();
    (0, _jquery2.default)(_constants.DOM_IDS.footer).remove();
    var body = (0, _jquery2.default)(document.body);
    if (config.parameters.footer) {
      var footer = _markup2.default.getFooter(config);
      body.append(footer);
    }
    if ((0, _jquery2.default)(_constants.DOM_IDS.header).length === 0) {
      var header = _markup2.default.getHeaderPlaceholder();
      body.prepend(header);
    }
  },
  final: function final(config) {
    (0, _jquery2.default)(_constants.DOM_IDS.header).remove();
    var body = (0, _jquery2.default)(document.body);
    var header = _markup2.default.getHeader(config);
    body.prepend(header);
    return body.find(_constants.DOM_IDS.header);
  }
};

exports.default = render;


//////////////////
// WEBPACK FOOTER
// ./node_modules/qc-global-navigation/src/render.js
// module id = 185
// module chunks = 0